import Permissions from '@security/permissions';
import PermissionChecker from '@modules/iam/permission-checker';

export class InscriptionPermissions {
    constructor(currentUser) {
        const permissionChecker = new PermissionChecker(
            currentUser,
        );

        this.read = permissionChecker.match(
            Permissions.values.inscriptionRead,
        );
        this.import = permissionChecker.match(
            Permissions.values.inscriptionImport,
        );
        this.inscriptionAutocomplete = permissionChecker.match(
            Permissions.values.inscriptionAutocomplete,
        );
        this.create = permissionChecker.match(
            Permissions.values.inscriptionCreate,
        );
        this.edit = permissionChecker.match(
            Permissions.values.inscriptionEdit,
        );
        this.destroy = permissionChecker.match(
            Permissions.values.inscriptionDestroy,
        );
    }
}